import React from 'react'
import { Button } from '../../../../components/Button/Button'
import { useNavigate } from 'react-router-dom'

export const ProfessionalSuccess: React.FC = () => {
  const navigate = useNavigate()

  return (
    <div className='d-flex flex-column gap-3 align-items-center text-center'>
      <div className='paragraph-medium'>
        You've just unlocked the powerful features for financial advisors. It's time to boost productivity and scale your practice.
      </div>
      <div className='d-flex align-items-center justify-content-center'>
        <Button variant='primary' className='button-medium' onClick={() => navigate('/workspace/upcoming')}>
          Go to meetings now
        </Button>
      </div>
    </div>
  )
}
